export const SERVERS__REACT_APP_API_BASE_URL = process.env.SERVERS__REACT_APP_API_BASE_URL;
export const SERVERS__REACT_APP_WS_BASE_URL = process.env.SERVERS__REACT_APP_WS_BASE_URL;
export const SERVERS__REACT_APP_ENABLE_ADMIN_UI = process.env.SERVERS__REACT_APP_ENABLE_ADMIN_UI;
export const MODE = process.env.MODE;

console.log('Environment Variables:');
console.log(`SERVERS__REACT_APP_API_BASE_URL: ${SERVERS__REACT_APP_API_BASE_URL}`);
console.log(`SERVERS__REACT_APP_WS_BASE_URL: ${SERVERS__REACT_APP_WS_BASE_URL}`);
console.log(`SERVERS__REACT_APP_ENABLE_ADMIN_UI: ${SERVERS__REACT_APP_ENABLE_ADMIN_UI}`);
console.log(`MODE: ${MODE}`);

